<template>
  <page-container>
    <template v-slot:page-fixed-header>
      <span class="text-h5 font-weight-bold ml-3 full-width page-header">{{
        $t("statistics.hAttendanceAnalysis")
      }}</span>
      <v-spacer></v-spacer>

      <v-tooltip
        bottom
        v-if="$security.checkUserAccess('ViewMeetingStatistics')"
      >
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-if="$security.checkUserAccess('ViewMeetingStatistics')"
            v-bind="attrs"
            v-on="on"
            class="mr-2"
            color="primaryDark"
            @click.stop="exportPDF()"
            :disabled="!filteredUsers.length"
            ><v-icon small>mdi-file-export</v-icon>
            {{ $t("agenda.tipExportPDF") }}
          </a-btn>
        </template>
        <span>{{ $t("agenda.tipExportPDF") }}</span>
      </v-tooltip>
      <component :is="importPDF" @load="isLoading" @pdfRender="pdfRender" />
      <v-tooltip
        bottom
        v-if="$security.checkUserAccess('ViewMeetingStatistics')"
      >
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-if="$security.checkUserAccess('ViewMeetingStatistics')"
            v-bind="attrs"
            v-on="on"
            class="mr-2"
            color="primaryDark"
            @click="$router.push({ path: '/statistics&analysis' })"
          >
            {{ $t("Back") }}
          </a-btn>
        </template>
        <span>{{ $t("Back") }}</span>
      </v-tooltip>
      <v-tooltip
        bottom
        v-if="$security.checkUserAccess('ViewMeetingStatistics')"
      >
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-if="$security.checkUserAccess('ViewMeetingStatistics')"
            v-bind="attrs"
            v-on="on"
            class="mr-2"
            color="primaryDark"
            @click="openDialog"
          >
            {{ $t("lblFilter") }}
          </a-btn>
        </template>
        <span>{{ $t("lblFilter") }}</span>
      </v-tooltip>
    </template>
    <template v-slot:page-content>
      <v-card tile flat style="width: 100%" color="Neutral">
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              class="pa-0"
              style="background-color: var(--v-Neutral-base)"
            >
              <v-data-iterator
                :items="filteredUsers"
                :items-per-page="-1"
                :footer-props="{
                  'items-per-page-text': $t('lblRowsPerPage'),
                }"
                :loading="loaderLoading"
                :no-results-text="$t('emptySearchRecords')"
                :loading-text="$t('LoaderText')"
                :no-data-text="$t('noData')"
              >
                <template v-slot:default="props">
                  <v-row>
                    <v-col
                      v-for="(item, index) in props.items"
                      :key="index"
                      cols="12"
                      sm="12"
                      md="6"
                      lg="4"
                      style="padding: 10px"
                    >
                      <user-card :item="item" :key="render"></user-card>
                    </v-col>
                  </v-row>
                </template>
                <template slot="no-data">
                  <v-row
                    justify="center"
                    v-if="!loaderLoading && !filteredUsers.length"
                  >
                    <v-card flat class="mx-auto d-flex" max-width="344">
                      <v-card-text class="align-center">
                        <p class="text-h5 text--primary mt-2 mx-2">
                          {{ $t("agenda.hRecordNotFound") }}
                        </p>
                      </v-card-text>
                    </v-card>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <filter-dialog
        v-if="isOpen"
        v-model="isOpen"
        @sessionFilterPayload="getFilterInput"
        :item="obj"
      ></filter-dialog>
      <Loader :loading="loaderLoading" :message="loaderText"></Loader>
    </template>
  </page-container>
</template>

<script>
import FilterDialog from "@/components/statistics/FilterDialog.vue";
import Loader from "@/components/Loader.vue";
import UserCard from "@/components/statistics/UserCard.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { formatDate } from "@/utils/util";
export default {
  name: "AttendanceAnalysis",
  components: {
    UserCard,
    Loader,
    FilterDialog,
  },
  data() {
    return {
      renderPDF: null,
      isOpen: false,
      filteredUsers: [],
      loaderLoading: false,
      render: 0,
      sessionStatisticsInputs: null,
      meetingTypeObj: {},
      userData: [],
      obj: {
        id: "attendance_analysis",
        title: this.$t("statistics.hAttendanceAnalysis"),
      },
    };
  },
  computed: {
    ...gettersMap(),
    ...mapState({
      statisticsData: (state) => state.admin.statisticsData,
      userList: (state) => state.people.userList,
    }),
    importPDF() {
      if (this.renderPDF) {
        return () => import(`@/components/statistics/AttendancePDF.vue`);
      }
      return null;
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    dateFormat() {
      return this.selectedLang !== "ja" ? "dd-MM-yyyy" : "yyyy-MM-dd";
    },
    loaderText() {
      return this.$t("LoaderText");
    },
    meetingTypesList() {
      if (this.meetingTypes && this.meetingTypes.length > 0) {
        return this.meetingTypes.filter((item) =>
          this.$security.checkMeetingTypeAccess(item.id, "CreateMeeting")
        );
      }
    },
  },
  watch: {
    async statisticsData(val) {
      this.filteredUsers = [];

      if (Object.keys(val).length) {
        await this.getUsers(val);
      }
    },
  },
  created() {
    let sessionFilterInputs = sessionStorage.getItem("statisticsFilterInputs");
    this.sessionStatisticsInputs = JSON.parse(sessionFilterInputs);
  },
  async mounted() {
    this.loaderLoading = true;

    if (!this.userList.length) {
      try {
        await this.getCachedUserList();
      } catch (error) {
        console.error(error);
      }
    }
    this.meetingTypesList.forEach((meetType) => {
      if (this.sessionStatisticsInputs?.meeting_type_id === meetType.id) {
        this.meetingTypeObj = meetType;
      }
    });
    this.userData = this.userList.filter((user) =>
      this.sessionStatisticsInputs?.user_ids.includes(user.id)
    );

    if (Object.keys(this.statisticsData).length) {
      await this.getUsers(this.statisticsData); // To set Filtered results
    } else if (this.sessionStatisticsInputs) {
      await this.getStatisticsData(this.sessionStatisticsInputs)
        .then(async (response) => {
          this.filteredUsers = [];
          await this.getUsers(response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loaderLoading = false;
        });
    }
    this.loaderLoading = false;
  },
  methods: {
    ...mapActions({
      getStatisticsData: "admin/getStatisticsData",
      getCachedUserList: "people/getCachedUserList",
    }),
    formatDate,
    exportPDF() {
      this.renderPDF = true;
    },
    pdfRender(val) {
      this.renderPDF = val;
    },
    getFilterInput(obj) {
      this.sessionStatisticsInputs = obj;
      this.render++;
    },
    isLoading(val) {
      this.loaderLoading = val;
    },
    openDialog() {
      this.isOpen = true;
    },
    getUsers(res) {
      for (const key in res) {
        if (res.hasOwnProperty(key)) {
          this.userList.forEach((user) => {
            const element = res[user.id];
            if (user.id === key) {
              user.attendanceData = element;
              this.filteredUsers.push(user);
              this.render++;
            }
          });
        }
      }
    },
  },
};
function gettersMap() {
  return mapGetters({
    meetingTypes: "tenant/agendaMeetingTypes",
  });
}
</script>

<style scoped>
</style>